<template>
  <div class="producer-old-debts-container">
    <s-crud ref="crud" title="Saldos / Deudas Antiguas de Productores" :config="configCrud" :filter="filter" add edit
      remove height="450" sortable @save="save($event)">
      <template v-slot:options>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" text black @click="showImportModal = true" small>
              <i class="fas fa-file-import"></i>
            </v-btn>
          </template>
          <span>Importar Excel</span>
        </v-tooltip>
      </template>

      <!-- Filtros de Búsqueda -->
      <template v-slot:filter>
        <v-container fluid>
          <v-row dense>
            <!-- Productor -->
            <v-col cols="12" sm="6" md="3" lg="3">
              <s-select-producer v-model="filter.PrdID" label="Productor" clearable autocomplete />
            </v-col>

            <!-- Campaña -->
            <v-col cols="12" sm="6" md="2" lg="2">
              <s-select-campaign-area v-model="filter.CmaID" label="Campaña" noDefault clearable typeArea="1" full />
            </v-col>

            <!-- Tipo de Deuda -->
            <v-col cols="12" sm="6" md="2" lg="2">
              <s-select-definition v-model="filter.TypeDebt" :def="1697" label="Tipo de Deuda" clearable />
            </v-col>

            <!-- Tipo de Deuda -->
            <v-col cols="12" sm="6" md="2" lg="2">
              <s-select-definition
                v-model="filter.TypeDebt"
                :def="1697"
                label="Tipo de Deuda"
                clearable
              />
            </v-col>

            <!-- Estado de Saldo -->
            <v-col cols="12" sm="6" md="2" lg="2">
              <s-select v-model="filter.StatusBalance" label="Estado de Saldo" :items="statusOptions" item-text="text"
                item-value="value" clearable outlined dense hide-details />
            </v-col>

            <!-- Rango de Fechas - Inicio -->
            <v-col cols="12" sm="3" md="1.5" lg="1.5">
              <s-date v-model="filter.BeginDate" label="F. Emisión Inicio" clearable />
            </v-col>

            <!-- Rango de Fechas - Fin -->
            <v-col cols="12" sm="3" md="1.5" lg="1.5">
              <s-date v-model="filter.EndDate" label="F. Emisión Fin" clearable />
            </v-col>
          </v-row>
        </v-container>
      </template>

      <!-- Grid Columns Customization -->
      <!-- Campaña -->
      <template v-slot:item.CmaName="{ item }">
        <div class="d-inline-flex align-center">
          <v-icon small color="blue-grey darken-2" class="mr-1">mdi-calendar-check</v-icon>
          <span class="font-weight-medium">{{
            item.CmaName || "Sin Campaña"
          }}</span>
        </div>
      </template>

      <!-- Fecha de Emisión -->
      <template v-slot:item.IssueDate="{ item }">
        <div class="text-center font-weight-medium">
          {{ item.IssueDate }}
        </div>
      </template>

      <!-- Monto Total -->
      <template v-slot:item.TotalAmount="{ item }">
        <div class="text-right font-weight-bold primary--text">
          S/ {{ formatNumber(item.TotalAmount) }}
        </div>
      </template>

      <!-- Saldo Total -->
      <template v-slot:item.TotalBalance="{ item }">
        <div class="text-right font-weight-bold error--text">
          S/ {{ formatNumber(item.TotalBalance) }}
        </div>
      </template>

      <!-- Estado de Saldo -->
      <template v-slot:item.StatusBalance="{ item }">
        <div class="text-center">
          <v-chip x-small label outlined :color="item.StatusBalance === 2 ? 'success' : 'warning'"
            class="font-weight-bold px-2 text-uppercase">
            <v-icon x-small left class="mr-1">
              {{
                item.StatusBalance === 2
                  ? "mdi-check-circle-outline"
                  : "mdi-clock-outline"
              }}
            </v-icon>
            {{ item.StatusBalance === 2 ? "Cancelado" : "Pendiente" }}
          </v-chip>
        </div>
      </template>

      <!-- Formulario de Creación / Edición -->
      <template slot-scope="props">
        <v-card flat class="pa-4 premium-form-card">
          <v-container fluid class="pa-0">
            <!-- Cabecera de Formulario Único -->
            <v-subheader class="pl-0 font-weight-bold text-uppercase primary--text mb-2">
              <v-icon color="primary" class="mr-2">mdi-cash-register</v-icon>
              Datos del Registro de Deuda
            </v-subheader>

            <v-row dense>
              <!-- Productor -->
              <v-col cols="12" md="4" class="s-col-form">
                <s-select-producer v-model="props.item.PrdID" label="Productor" :disabled="props.item.PdeID > 0"
                  autocomplete />
              </v-col>

              <!-- Campaña -->
              <v-col cols="12" md="3" class="s-col-form">
                <s-select-campaign-area v-model="props.item.CmaID" label="Campaña" noDefault typeArea="1" full />
              </v-col>

              <!-- Tipo de Deuda -->
              <v-col cols="12" md="3" class="s-col-form">
                <s-select-definition v-model="props.item.TypeDebt" :def="1697" label="Tipo de Deuda" />
              </v-col>

              <!-- Tipo de Deuda -->
              <v-col cols="12" md="3" class="s-col-form">
                <s-select-definition
                  v-model="props.item.TypeDebt"
                  :def="1697"
                  label="Tipo de Deuda"
                />
              </v-col>
            </v-row>

            <v-row dense class="mt-4">
              <!-- Fecha de Emisión -->
              <v-col cols="12" sm="2" class="s-col-form">
                <s-date v-model="props.item.IssueDate" label="Fecha de Emisión" />
              </v-col>

              <!-- Monto Total -->
              <v-col cols="12" sm="2" class="s-col-form">
                <s-text type="number" v-model.number="props.item.TotalAmount" label="Monto Total" prefix="S/" />
              </v-col>
            </v-row>

            <!-- Observación -->
            <v-row dense class="mt-4">
              <v-col cols="4" class="s-col-form">
                <s-textarea v-model="props.item.Observation" label="Observaciones / Comentarios" />
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </template>
    </s-crud>

    <!-- Componente Modal de Importación -->
    <ProducerOldDebtsImportModal :isOpen.sync="showImportModal" @close="showImportModalFunction" />
  </div>
</template>

<script>
import _ProducerOldDebtsService from "@/services/Technicalassistance/ProducerOldDebtsService";
import SSelectProducer from "@/components/HarvestSchedule/SSelectProducer";
import SSelectCampaignArea from "@/components/Utils/SSelectCampaignArea";
import SSelectDefinition from "@/components/Utils/SSelectDefinition";
import ProducerOldDebtsImportModal from "@/components/TecnicalAssistence/ProducerOldDebts/ProducerOldDebtsImportModal.vue";

export default {
  name: "ProducerOldDebts",
  components: {
    SSelectProducer,
    SSelectCampaignArea,
    SSelectDefinition,
    ProducerOldDebtsImportModal,
  },
  data() {
    return {
      showImportModal: false,
      filter: {
        PrdID: null,
        CmaID: null,
        StatusBalance: null,
        BeginDate: null,
        EndDate: null,
        TypeDebt: null,
      },
      statusOptions: [
        { text: "Pendiente", value: 1 },
        { text: "Cancelado", value: 2 },
      ],
      configCrud: {
        service: _ProducerOldDebtsService,
        model: {
          PdeID: "ID",
          IssueDate: "date",
          PrdID: "int",
          CmaID: "int",
          TypeDebt: "int",
          TotalAmount: "decimal",
          TotalBalance: "decimal",
          StatusBalance: "int",
          Observation: "string",
          SecStatus: "int",
        },
        headers: [
          {
            text: "ID",
            value: "PdeID",
            width: "80",
            align: "center",
            sortable: true,
          },
          { text: "Productor", value: "ProducerName", sortable: true },
          { text: "Campaña", value: "CmaName", width: "150", sortable: true },
          { text: "Tipo Deuda", value: "TypeDebtName", width: "150", sortable: true },
          {
            text: "Fecha Emisión",
            value: "IssueDate",
            width: "130",
            align: "center",
            sortable: true,
          },
          {
            text: "Monto Total",
            value: "TotalAmount",
            width: "130",
            align: "end",
            sortable: true,
          },
          {
            text: "Saldo Total",
            value: "TotalBalance",
            width: "130",
            align: "end",
            sortable: true,
          },
          {
            text: "Estado Saldo",
            value: "StatusBalance",
            width: "130",
            align: "center",
            sortable: true,
          },
          { text: "Observación", value: "Observation", sortable: false },
        ],
      },
    };
  },
  methods: {
    formatNumber(value) {
      if (value === null || value === undefined || isNaN(value) || value === "")
        return "0.00";
      return parseFloat(value).toLocaleString("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    save(item) {
      // Validaciones básicas
      if (!item.PrdID || item.PrdID <= 0) {
        this.$fun.alert("Seleccione un productor válido", "warning");
        return;
      }
      if (!item.CmaID || item.CmaID <= 0) {
        this.$fun.alert("Seleccione una campaña válida", "warning");
        return;
      }
      if (!item.TypeDebt || item.TypeDebt <= 0) {
        this.$fun.alert("Seleccione un tipo de deuda válido", "warning");
        return;
      }
      if (!item.IssueDate) {
        this.$fun.alert(
          "Seleccione la fecha de emisión de la deuda",
          "warning",
        );
        return;
      }
      if (
        item.TotalAmount === null ||
        item.TotalAmount === undefined ||
        item.TotalAmount === "" ||
        item.TotalAmount < 0
      ) {
        this.$fun.alert(
          "Ingrese un monto total válido (mayor o igual a cero)",
          "warning",
        );
        return;
      }
      // Si es un nuevo registro, el saldo total inicial es igual al monto total, y el estado es Pendiente (1)
      if (!item.PdeID || item.PdeID <= 0) {
        item.TotalBalance = item.TotalAmount;
        item.StatusBalance = 1;
      }

      // Valores predeterminados para campos de auditoría
      item.SecStatus = item.SecStatus || 1;

      // Auditoría de usuario
      if (item.PdeID > 0) {
        item.UsrUpdateID = parseInt(this.$fun.getUserID());
      } else {
        item.UsrCreateID = parseInt(this.$fun.getUserID());
      }

      // Guardar el registro a través del framework s-crud
      item.save();
    },
    showImportModalFunction() {
      this.showImportModal = false;
      this.$refs.crud.refresh();
    },
  },
};
</script>

<style scoped>
.producer-old-debts-container {
  padding: 8px;
}

.premium-form-card {
  background-color: #fafafa !important;
  border-radius: 8px !important;
  border: 1px solid rgba(0, 0, 0, 0.05) !important;
}

.premium-textarea :deep(.v-input__control) {
  border-radius: 4px;
}

.v-subheader {
  font-size: 0.8rem;
  letter-spacing: 0.5px;
}
</style>
